import React from "react";
import { Slide } from "react-reveal";
import about1 from "../../assets/images/content1/6.png";
import about2 from "../../assets/images/content1/1.png";
import about3 from "../../assets/images/content1/11.png";

const AboutHome = () => {
  return (
    <section className="section section-spacing-20 no-padding-bottom cloudy-bg">
      <div className="container">
        <div className="large">
          <div className="section-content section-spacing-100 no-padding-top">
            <div className="about-contents relative flex">
              <Slide left>
                <div className="about-image-side images-side flex">
                  <img
                    src={about3}
                    className="box-shadow"
                    alt="Negash Project"
                  />
                  <img
                    src={about2}
                    className="box-shadow"
                    alt="Negash Project"
                  />
                  <img
                    src={about1}
                    alt="Negash Project"
                    className="about-big-img box-shadow"
                  />
                </div>
              </Slide>
              <div className="about-text-side">
                <p className="section-name boldTitle dark">ABOUT US</p>
                <Slide top>
                  <div className="section-head">
                    <h2 className="section-title green">
                      INTEGRITY. EXCELLENCE. RELIABILITY.
                    </h2>
                    <p className="section-subtitle margin-top-bottom-10">
                      Negash Construction Company is a leading South Sudanese
                      construction firm recognized for quality, integrity, and
                      reliability. Founded by Mr. Negash Tesfatsion, who brings
                      over 25 years of experience, the company has grown into
                      one of Juba’s top contractors.
                    </p>
                    <p>
                      Guided by our motto “We Deliver,” Negash Construction
                      provides innovative, sustainable solutions across
                      residential, commercial, and infrastructure projects —
                      building not just structures, but lasting trust and
                      progress for South Sudan.
                    </p>
                  </div>
                </Slide>
                <div className="section-footer buttons-container flex justify-center section-spacing-20 no-padding-bottom">
                  <a
                    href="/about-us"
                    className="button sub-cta boldTitle dark uppercase"
                  >
                    Read More &#8594;
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHome;
